var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    width: 28.8,
    height: 28.8,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 236.9a9.1 9.1 0 01-7.2-3.5L108.6 149l64.3-82.4a9 9 0 1114.2 11l-55.7 71.5 55.8 73.4a9 9 0 01-7.2 14.4z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzAwIDMwMCIgd2lkdGg9IjI4LjgiIGhlaWdodD0iMjguOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTgwIDIzNi45YTkuMSA5LjEgMCAwMS03LjItMy41TDEwOC42IDE0OWw2NC4zLTgyLjRhOSA5IDAgMTExNC4yIDExbC01NS43IDcxLjUgNTUuOCA3My40YTkgOSAwIDAxLTcuMiAxNC40eiI+PC9wYXRoPjwvc3ZnPg==";
export { SvgIconChevronLeft as ReactComponent };